import { render } from "./showformmodel.vue?vue&type=template&id=4d489717&scoped=true"
import script from "./showformmodel.vue?vue&type=script&lang=js"
export * from "./showformmodel.vue?vue&type=script&lang=js"

import "./showformmodel.vue?vue&type=style&index=0&id=4d489717&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d489717"]])

export default __exports__